import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { MomentModule } from 'angular2-moment';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';
import 'moment/locale/pt-br';

import { CampaignRoutingModule } from './campaign-routes';

import { CampaignsComponent } from './campaigns.component';
import { SpecialComponent } from './specials/special.component';
import { BasicComponent } from './basic/basic.component';
import { DirectShipComponent } from './direct-ship/direct-ship.component';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentsModule } from '../../components/components.module';
import { HttpClient } from '@angular/common/http';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from '../../components/modal/modal.module';
import { CustomAdapter, CustomDateParserFormatter } from '../../services/date-handler.service';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    CampaignsComponent,
    SpecialComponent,
    BasicComponent,
    DirectShipComponent,
  ],
  imports: [
    FormsModule,
    MomentModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    FormsModule,
    CampaignRoutingModule,
    NgxDatatableModule,
    ComponentsModule,
    NgbModule,
    ReactiveFormsModule,
    ModalModule
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})

export class CampaignModule {}
